import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("tpa_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  // Send subdomain (excluding common prefixes) so the backend can resolve tenant-specific branding.
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  const parts = host.split(".");
  const sub = parts.length >= 3 ? parts[0].toLowerCase() : "";
  const IGNORE = new Set(["www", "app", "preview", "localhost"]);
  if (sub && !IGNORE.has(sub) && !host.includes("emergentagent.")) {
    cfg.headers["X-Tenant-Subdomain"] = sub;
  }
  return cfg;
});
